import { MAX_PHONE_LENGTH } from '@/constants/Common'
import {
  EMAIL_REQUIRED,
  FIRSTNAME_REQUIRED,
  FULLNAME_NO_SPECIAL,
  LASTNAME_REQUIRED,
  PHONE_INVALID,
} from '@/constants/MessageConstants'
import * as Yup from 'yup'

export const createInvitePlayerValidationSchema = () => {
  return Yup.object().shape({
    firstName: Yup.string()
      .required(FIRSTNAME_REQUIRED)
      .matches(/^[A-Za-z ]+$/, FULLNAME_NO_SPECIAL),
    lastName: Yup.string()
      .required(LASTNAME_REQUIRED)
      .matches(/^[A-Za-z ]+$/, FULLNAME_NO_SPECIAL),
    email: Yup.string().email().required(EMAIL_REQUIRED),
    phoneNumber: Yup.string().max(MAX_PHONE_LENGTH, PHONE_INVALID),
  })
}
